import { createFileRoute } from '@tanstack/react-router'
import { AboutFeature } from '@/features/about/AboutFeature'

export const Route = createFileRoute('/about')({
  component: AboutPage,
})

function AboutPage() {
  return <AboutFeature />
}
